import Generator from '../../Generator'
import Types from '../../../actions/Types'

export default Generator.node({
  baseType: Types.PRINT.OWNER,
  nodeType: Generator.NODETYPE.PRINT
})



// WEBPACK FOOTER //
// ./src/reducers/root/print/owner.js